// AppMain.js
import React, {useEffect, useState, useRef} from 'react';
import { styled  } from '@mui/material/styles';
import { Box } from '@mui/system';
import { IconButton, Menu, MenuItem, Popover } from '@mui/material';
import { useMutation, useReactiveVar } from '@apollo/client';
import ClearIcon from '@mui/icons-material/Clear';
import HomeWorkIcon from '@mui/icons-material/HomeWork';
import MenuIcon from '@mui/icons-material/Menu';
import InfoIcon from '@mui/icons-material/Info';
import { AppConfirmDialogProvider } from '../../common/AppConfirmDialog';
import { NonCapButton } from '../../common/VzmStyled';
import {
    AppObject, AppStyle, AppWord, AppServiceUrl, AppMenuUrl, ApiMsg
} from '../../value/AppConst';
import {
    currentMenuRepo, menuRequestRepo, menuTreeRepo,
    clearReposForNewSession, userInfoRepo
} from '../../value/AppModel';
import AppHeader from './AppHeader';
import NotImplemented from './NotImplemented';
import TopHome from '../home/TopHome';
import AutoPlanBaseInfo from '../auto_plan_base_info/AutoPlanBaseInfo';
import BbsPkg from '../bbs_pkg/BbsPkg';
import CommonCode from '../common_code/CommonCode';
import DcAndStore from '../dc_and_store/DcAndStore';
import DcVehBanState from '../dc_veh_ban_state/DcVehBanState';
import FileCreateHisDeliveryReport from '../file_create_his/FileCreateHisDeliveryReport'; // 출고실적 리포트
import FileCreateHisTransportReport from '../file_create_his/FileCreateHisTransportReport'; // 운송실적 리포트
import FileCreateHisArrivalOnTimeReport from '../file_create_his/FileCreateHisArrivalOnTimeReport'; // 정시도착 리포트
import FileCreateHisTemperatureReport from '../file_create_his/FileCreateHisTemperatureReport'; // 온도관제 리포트
import FileCreateHisTsrResultReport from '../file_create_his/FileCreateHisTsrResultReport'; // TSR결과 리포트
import FileCreateHisStoreTransportReport from '../file_create_his/FileCreateHisStoreTransportReport'; // 점포운송 리포트
import MenuInfo from '../menu_info/MenuInfo';
import UserAndAlloc from '../user_info/UserAndAlloc';
import VehTypeManager from '../veh_type_group/VehTypeManager';
import VehInfo from '../veh_info/VehInfo';
import VehInfoMyDcRented from '../veh_info/VehInfoMyDcRented';
import MaskDsc from '../login/MaskDsc'; // 센터 전환 Dialog
import { MASK_DSC } from '../login/AppLoginGql';
import { useAlertSetter } from '../../api/app-hook';
import UserSessionInfo from '../../value/UserSessionInfo';
import { enqueueSnackbar } from 'notistack';
import ValueMisc from '../../value/ValueMisc';
import TransPlan from '../trans_plan/TransPlan';
import RtdTermPos from '../rtd_term_pos/RtdTermPos';
import VehRoute from '../veh_route/VehRoute';
import DcTemperature from '../dc_temp_info/DcTemperature';
import VehInfoList from '../veh_info/VehInfoList';
import TransPlanStateForDc from '../trans_plan_and_actor/TransPlanStateForDc';
import TransPlanStateForCompany from '../trans_plan_and_actor/TransPlanStateForCompany';
import TransPlanTravel from '../trans_plan_travel/TransPlanTravel';
import ArrivalToStore from '../arrival_to_store/ArrivalToStore';
import TransPlanTsr from '../trans_plan_tsr/TransPlanTsr';
import StoreInfoForStore from '../store_info/StoreInfoForStore';
import TransPlanTsrByStore from '../trans_plan_tsr/TransPlanTsrByStore';
import SmsMessage from '../sms_message/SmsMessage';
import TransPlanLaunchAndDownload from '../trans_plan_launch/TransPlanLaunchAndDownload';
import AutoPlanUpload from '../auto_plan_upload/AutoPlanUpload';
import TruckerTransPlan from '../trucker_trans_plan/TruckerTransPlan';
import UserInfoInputMine from '../user_info/UserInfoInputMine';
import UserInfoChangePassword from '../user_info/UserInfoChangePassword';
import BulkCompany from '../bulk_company/BulkCompany';

const MainContainer = styled(Box)({
    position: 'fixed', top: AppStyle.AppHeaderHeight,
    right: 0, bottom: AppStyle.AppFooterHeight + 10, left: 0,
    display: 'flex', flexDirection: 'column', // backgroundColor: '#0ff'
});

const ViewTabBox = styled(Box)({
    height: AppStyle.AppViewTabHeight, backgroundColor: '#c9c9c9', borderBottom: '1px solid #999',
    display: 'flex', alignItems: 'center', //paddingLeft: 20
});

const ViewTab = styled(Box)({
    height: '100%', cursor: 'pointer', color:'#333',
    paddingLeft: 2, paddingRight: 3, borderRight: '2px solid white',
    display: 'inline-flex', alignItems: 'center', boxSizing: 'border-box',
    '&:hover': {color: 'red'},
    '&:first-of-type': {borderLeft: '2px solid white'},
});

const ShortHelpBox = styled(Box)({
    position: 'absolute', top: 0, right: 0, 
    flexGrow: 1, display: 'flex', alignItems: 'center', fontSize: '0.89rem', justifyContent: 'end',
});
const ShortHelpText = styled(Box)({color: '#f09',marginRight: 10});

const PopHelpBox = styled(Box)({
    fontSize: '0.9rem', padding: 10, width: 360,
});

const ContentBox = styled(Box)({
    flexGrow: 1, overflow: 'auto', position: 'relative',
});

/**
 * 로그인된 상태에서 메인 화면을 구성하는 컴포넌트
 * @returns 
 */
export default function AppMain() {
    const sessionInfo = useReactiveVar(userInfoRepo);
    const currentMenu = useReactiveVar(currentMenuRepo);
    const menuRequest = useReactiveVar(menuRequestRepo);
    const menuTree = useReactiveVar(menuTreeRepo);
    const [appViews, setAppViews] = useState([]);
    const [openMaskDc, setOpenMaskDc] = useState(false);
    const [openEditMyInfo, setOpenEditMyInfo] = useState(false);
    const [openChangeMyPassword, setOpenChangeMyPassword] = useState(false);
    const [homeTabAnchorEl, setHomeTabAnchorEl] = useState(null);
    const [helpAnchorEl, setHelpAnchorEl] = useState(null);
    const addAlert = useAlertSetter();
    const startRef = useRef(0);
    const viewTabBoxRef = useRef(null);
    const lastMenuBySvcRef = useRef({});

    const [maskDc, responseMaskDc] = useMutation(MASK_DSC, {
        ...AppObject.NoCachedFetch,
        onCompleted: (data, option) => {onCompleteMaskingDc(data, option)},
        onError: (error) => { addAlert({title:'센터 전환 오류', message:[error.message]})},
    });

    const clearAllTabsButHome = () => {
        const homeView = appViews[0] || {
            menu: AppObject.HomeMenu.menu,
            parentMenu: null,
            when: new Date(),
        };
        setAppViews([homeView]);
        currentMenuRepo({menu:AppObject.HomeMenu.menu, parentMenu:null});
        setHomeTabAnchorEl(null);
    };

    const onCompleteMaskingDc = (data, clientOption) => {
        if(data.maskDsc) {
            if(data.maskDsc.sessionNote === ApiMsg.OK) {
                const session = UserSessionInfo.initFromUserObject(data.maskDsc);
                clearReposForNewSession();
                clearAllTabsButHome();
                userInfoRepo(session);
                enqueueSnackbar('센터 전환되었습니다.', {variant:'success', autoHideDuration:2500});

                setOpenMaskDc(false);
            }
            else {
                addAlert({
                    title: '센터 전환 오류',
                    message: [
                        '센터 전환에 실패했습니다.',
                        data.maskDsc.sessionNote
                    ]
                })
            }
        }
        else {
            addAlert({title:'센터 전환 오류', message:['알 수 없는 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.']});
        }
    };


    const getViewFromMenu = (menu, parentMenu) => {
        const murl = menu.menuUrl;
        const svcUrl = menu.svcUrl;
        // 홈 화면
        if(murl === AppObject.HomeMenu.menu.menuUrl) return <TopHome />;
        // ### 게시판 ########################################
        // 게시판관리
        if(svcUrl === AppServiceUrl.BBS) return <BbsPkg menu={menu} parentMenu={parentMenu}/>;
        // ### 기초정보 ########################################
        //	사용자관리
        if(svcUrl === AppServiceUrl.UserInfo) return <UserAndAlloc menu={menu} parentMenu={parentMenu} />;
        //	출발지 도착지 관리
        if(svcUrl === AppServiceUrl.DcArrive) return <DcAndStore menu={menu} parentMenu={parentMenu} />;
        // 메뉴관리
        if(murl === AppMenuUrl.Menu) return <MenuInfo />;
        // 차종관리
        if(murl === AppMenuUrl.VehTypeGroup) return <VehTypeManager />;
        // 공통코드관리
        if(murl === AppMenuUrl.CommonCode) return <CommonCode />;
        // 점포관리 (for Store User)
        if(murl === AppMenuUrl.StoreInfoTab) return <StoreInfoForStore />;
        // Bulk 상품 및 업체 관리
        if(murl === AppMenuUrl.Bulk) return <BulkCompany />;
        // ### 자동배차 ########################################
        // 상온 자동배차 기초 정보
        if(svcUrl === AppServiceUrl.AutoBaseA) return <AutoPlanBaseInfo menu={menu} parentMenu={parentMenu}/>;
        // 상온 자동배차
        if(murl === AppMenuUrl.AutoPlanA) return <AutoPlanUpload />;
        // ### 배차 ########################################
        // 차량등록현황
        if(murl === AppMenuUrl.VehInfo) return <VehInfoList />;
        // 운송요청 등록
        if(svcUrl === AppServiceUrl.TransPlan) return <TransPlanLaunchAndDownload menu={menu} parentMenu={parentMenu} />;
        // if(murl === AppMenuUrl.TransPlan) return <TransPlanLaunch />;
        // 배송상태 현황
        if(murl === AppMenuUrl.TransPlanBindState) return <TransPlanTravel />;
        // TSR 발행
        if(murl === AppMenuUrl.TSR) return <TransPlanTsr />;
        // TSR 발행 (점포용, 메뉴에는 없음)
        if(murl === AppMenuUrl.StoreTSR) return <TransPlanTsrByStore />;
        // 배차현황 (물류센터)
        if(murl === AppMenuUrl.TransPlanState) return <TransPlanStateForDc />;
        // 점포관리 (물류센터)
        if(murl === AppMenuUrl.Store) return <ArrivalToStore />;
        // 배차금지 및 제한
        if(murl === AppMenuUrl.BanAndLimit) return <DcVehBanState />;
        // ### 차량관제 ########################################
        //	차량등록 리스트
        if(svcUrl === AppServiceUrl.VehRegister) return <VehInfo menu={menu} parentMenu={parentMenu} />;
        // 차량관제 리스트
        if(murl === AppMenuUrl.VehTransPos) return <TransPlan />;
        // 차량위치 리스트
        if(murl === AppMenuUrl.VehLocation) return <RtdTermPos />;
        // 차량경로 리스트
        if(murl === AppMenuUrl.VehRoute) return <VehRoute />;
        // 온도관제 리스트
        if(murl === AppMenuUrl.Temp) return <DcTemperature />;
        // ### 리포트 ########################################
        // 출고실적 Report
        if(murl === AppMenuUrl.UnStoreResultReport) return <FileCreateHisDeliveryReport />;
        // 운송실적 Report
        if(murl === AppMenuUrl.TransPlanReport) return <FileCreateHisTransportReport />;
        // 정시도착 Report
        if(murl === AppMenuUrl.OnTimeArriveReport) return <FileCreateHisArrivalOnTimeReport />;
        // 온도관제 Report
        if(murl === AppMenuUrl.TempReport) return <FileCreateHisTemperatureReport />;
        // TSR결과 Report
        if(murl === AppMenuUrl.TSRResultReport) return <FileCreateHisTsrResultReport />;
        // 점포운송 Report
        if(murl === AppMenuUrl.StoreTransReport) return <FileCreateHisStoreTransportReport />;
        // ### 운송사 ########################################
        // 홈플러스 배차현황
        if(murl === AppMenuUrl.ComTransPlanState) return <TransPlanStateForCompany />;
        // 홈플러스 배차등록
        if(murl === AppMenuUrl.ComTransPlan) return <TruckerTransPlan />;
        // 홈플러스 운송실적 Report (운송사용)
        if(murl === AppMenuUrl.HpTransPlanReport)
            return <FileCreateHisTransportReport forTruckCom={true} />;
        // 홈플러스 정시도착 Report (운송사용)
        if(murl === AppMenuUrl.HpOnTimeArriveReport)
            return <FileCreateHisArrivalOnTimeReport forTruckCom={true} />;
        // 용차관리
        if(murl === AppMenuUrl.TraRent) return <VehInfoMyDcRented />;
        // SMS 보내기
        if(murl === AppMenuUrl.TraSMS) return <SmsMessage />;
    
        return <NotImplemented menu={menu} parentMenu={parentMenu} />;
    };

    useEffect(() => {
        if(startRef.current===0) {
            //getCommonCodeTree();
            //getAuthTable();
            //getCodeTreeAndAuthTable();

            setAppViews([{
                menu:AppObject.HomeMenu.menu,
                parentMenu:null,
                when: new Date()
            }]);
            currentMenuRepo({menu:AppObject.HomeMenu.menu, parentMenu:null});
            startRef.current = 1;
        }
    }, []);

    // Menu 선택이 아닌 app 어디서든 메뉴를 요청하는 경우 이 queue를 통해 요청이 들어온다.
    // startRef.current가 1이 된 후에만 동작한다.
    useEffect(()=>{
        if(Boolean(menuRequest) && startRef.current === 1 && appViews.length > 0) {
            onMenuSelected(menuRequest.menu, menuRequest.parentMenu);
            menuRequestRepo(null); // consume once
        }
    }, [menuRequest, appViews.length]);

    const findOldestView = () => {
        if(appViews.length < 2) return null;
        const views = appViews.filter((view)=>view.menu.menuUrl !== AppObject.HomeMenu.menu.menuUrl);
        let oldestView = views.shift();
        views.forEach((viewSet) => {
            if(viewSet.when < oldestView.when) oldestView = viewSet;
        });
        return oldestView;
    };

    const onMenuSelected = (menu, parentMenu) => {
        let realMenu, realParentMenu;
        if(parentMenu) {
            realMenu = menu;
            realParentMenu = parentMenu;
        }
        else {
            if(menu.children) {
                realMenu = menu.children[0];
                realParentMenu = menu;
            
            }
            else {
                realMenu = menu;
                realParentMenu = null;
            }
        }

        if(realMenu.menuUrl === AppMenuUrl.centerState) {
            if(sessionInfo.user.hasHomeplusPower())
                setOpenMaskDc(true);
            else
                addAlert({title: '허용되지 않는 기능', message: ['허용된 사용자만 센터 전환을 할 수 있습니다.']});
            return;
        }
        else if(realMenu.menuUrl === AppMenuUrl.LocationMap) {
            const mapUrl = ValueMisc.getUrlBase() + '#' + AppWord.MAP_SUB_URL;
            window.open(mapUrl, AppWord.MAP_WINDOW_NAME);
            return;
        }

        if(realParentMenu && realMenu.svcUrl) {
            lastMenuBySvcRef.current[realMenu.svcUrl] = {
                menu: realMenu,
                parentMenu: realParentMenu,
            };
        }

        // svcUrl은 parent menu를 의미한다.
        const viewSetExist = realParentMenu
            ? appViews.find((viewSet) => viewSet.menu.svcUrl === realMenu.svcUrl)
            : appViews.find((viewSet) => viewSet.menu.menuId === realMenu.menuId);
        if(viewSetExist) {
            // realParentMenu 참: Parent menu가 같은 경우 또는 메뉴자신이 같은 경우이다.
            if(!realParentMenu) {
                viewSetExist.when = new Date();
                viewSetExist.menu = realMenu;
                viewSetExist.parentMenu = realParentMenu;

                const newAppViews = [];
                appViews.forEach((viewSet) => {
                    if(viewSet.menu.menuId === realMenu.menuId) newAppViews.push(viewSetExist);
                    else newAppViews.push(viewSet);
                });

                setAppViews(newAppViews);
            }
        }
        else {
            // Check if view tabs would be overflown. If so, remove the oldest view using when attribute(Date).
            const viewTabBox = viewTabBoxRef.current;
            const viewChildren = viewTabBox.children;
            const childrenWidth = Array.from(viewChildren).reduce(
                (acc, child) => acc + child.clientWidth+5, 250
            );
            let newViews;
            // 넘칠것 같으면 가장 오래된 view를 제거한다.
            if(childrenWidth > viewTabBox.offsetWidth) {
                const oldest = findOldestView();
                if(oldest)
                    newViews = appViews.filter((viewSet) => viewSet.menu.menuId !== oldest.menu.menuId);
                //setAppViews(newViews);
            }
            else newViews = [...appViews];
            // Add new view in front of the list.
            // 가장 앞에는 언제나 HomeView를 넣는다.
            const homeView = newViews.shift() || {
                menu: AppObject.HomeMenu.menu,
                parentMenu: null,
                when: new Date(),
            };
            setAppViews([homeView, {menu:realMenu, parentMenu:realParentMenu, when:new Date()}, ...newViews]);
        }

        currentMenuRepo({menu:realMenu, parentMenu:realParentMenu});
    };

    const onClickHomeLogo = () => {
        if(currentMenu.menu.menuId !== AppObject.HomeMenu.menu.menuId)
            currentMenuRepo({menu:AppObject.HomeMenu.menu, parentMenu:null});
    };

    const findByMenuUrl = (menuList, menuUrl) => {
        for(let i=0; i<menuList.length; i++) {
            const node = menuList[i];
            if(node.menuUrl === menuUrl) return node;
            if(node.children) {
                const found = findByMenuUrl(node.children, menuUrl);
                if(found) return found;
            }
        };
        return null;
    };

    const onClickGoBbs = () => {
        const bbsExist = appViews.find((viewSet) => viewSet.menu.svcUrl === AppServiceUrl.BBS);
        if(bbsExist) {
            currentMenuRepo({menu:bbsExist.menu, parentMenu:bbsExist.parentMenu});
            return;
        }
        const bbsMenu = findByMenuUrl(menuTree, AppServiceUrl.BBS);
        if(bbsMenu) {
            onMenuSelected(bbsMenu.children[0], bbsMenu);
        }
        else {
            currentMenuRepo({menu:AppObject.HomeMenu.menu, parentMenu:null});
        }
    };

    const onClickViewTab = (viewSet) => {
        if(viewSet.menu.menuId !== currentMenu.menu.menuId) {
            if(viewSet.parentMenu && viewSet.menu.svcUrl) {
                const remembered = lastMenuBySvcRef.current[viewSet.menu.svcUrl];
                if(remembered && remembered.menu && remembered.parentMenu) {
                    currentMenuRepo({menu:remembered.menu, parentMenu:remembered.parentMenu});
                    return;
                }
            }
            currentMenuRepo({menu:viewSet.menu, parentMenu:viewSet.parentMenu});
        }
    };

    const isSameViewTab = (viewSet, menuState) => {
        if(!viewSet || !menuState || !menuState.menu) return false;
        return viewSet.parentMenu
            ? viewSet.menu.svcUrl === menuState.menu.svcUrl
            : viewSet.menu.menuId === menuState.menu.menuId;
    };

    const onClickCloseView = (viewSet) => {
        if(appViews.length === 1) return;

        // Find if this is the current view. If so, select the next or prev view.
        if(isSameViewTab(viewSet, currentMenu)) {
            const idx = appViews.findIndex((view) => isSameViewTab(view, currentMenu));
            const nextView = idx === appViews.length-1
                ? appViews[idx-1]
                : appViews[idx+1];

            if(nextView.parentMenu && nextView.menu.svcUrl) {
                const remembered = lastMenuBySvcRef.current[nextView.menu.svcUrl];
                if(remembered && remembered.menu && remembered.parentMenu) {
                    currentMenuRepo({menu:remembered.menu, parentMenu:remembered.parentMenu});
                }
                else {
                    currentMenuRepo({menu:nextView.menu, parentMenu:nextView.parentMenu});
                }
            }
            else {
                currentMenuRepo({menu:nextView.menu, parentMenu:nextView.parentMenu});
            }
        }
        setAppViews(appViews.filter((view) => !isSameViewTab(view, {menu:viewSet.menu, parentMenu:viewSet.parentMenu})));
    };

    // Clear all views except HomeView.
    const onClickClearAllViews = () => {
        clearAllTabsButHome();
    };

    const onRequestOpenMaskDc = () => {
        setOpenMaskDc(true);
    };

    const onRequestMask = (dcInfoItem) => {
        // if null, unmask (use user's own dc)
        const param = dcInfoItem ?
        {variables: {dscId: dcInfoItem.dcCd, dscName: dcInfoItem.dcName}} :
        {variables: {dscId: sessionInfo.user.dscId, dscName: sessionInfo.user.dscName}};
        maskDc(param);
    };

    return (
        <AppConfirmDialogProvider>
            <MainContainer>
                <ViewTabBox ref={viewTabBoxRef}>
                    {appViews.map((viewSet, index) => {
                        const menu = viewSet.menu;
                        const isCurrentView = viewSet.parentMenu
                            ? menu.svcUrl === currentMenu.menu.svcUrl
                            : menu.menuId === currentMenu.menu.menuId;
                        return(
                            <ViewTab key={menu.menuId}
                                style={
                                    isCurrentView ?
                                    {
                                        backgroundColor:'#fff', color:AppStyle.PrimaryRGB,
                                        borderBottom: '2px solid '+AppStyle.HomeplusRed
                                    }
                                    : null
                                }
                            >
                                <NonCapButton
                                    onClick={()=>onClickViewTab(viewSet)}
                                    size={AppWord.SMALL} color={AppStyle.mui.inherit}
                                >
                                    {
                                        menu.menuId === AppObject.HomeMenu.menu.menuId ?
                                        <HomeWorkIcon
                                            style={{fontSize:'16pt', color:AppStyle.HomeplusRed}}
                                        />
                                        :
                                        viewSet.parentMenu ? viewSet.parentMenu.menuName :
                                        menu.menuName
                                    }
                                </NonCapButton>
                                {
                                    appViews.length > 1 ?
                                    (
                                    menu.menuId === AppObject.HomeMenu.menu.menuId ?
                                    <IconButton size={AppWord.SMALL}
                                        color={AppStyle.mui.inherit}
                                        style={{width:16,height:16, marginRight: 5}}
                                        onClick={(e)=>setHomeTabAnchorEl(e.currentTarget)}
                                    >
                                        <MenuIcon style={{fontSize:'10pt'}}/>
                                    </IconButton>
                                    :
                                    <IconButton size={AppWord.SMALL}
                                        color={AppStyle.mui.inherit}
                                        style={{width:16,height:16}}
                                        onClick={()=>onClickCloseView(viewSet)}
                                    >
                                        <ClearIcon style={{fontSize:'10pt'}}/>
                                    </IconButton>
                                    ) : null
                                }
                            </ViewTab>
                        );
                    })}
                    <Menu
                        anchorEl={homeTabAnchorEl}
                        open={Boolean(homeTabAnchorEl)}
                        onClose={()=>setHomeTabAnchorEl(null)}
                    >
                        <MenuItem onClick={onClickClearAllViews}
                            style={{fontSize:'0.85rem'}}
                        >우측 탭 모두 닫기</MenuItem>
                    </Menu>
                </ViewTabBox>
                {/* renderCurrentView() */
                    appViews.map((viewSet, index) => {
                        const isCurrentView = viewSet.parentMenu
                            ? viewSet.menu.svcUrl === currentMenu.menu.svcUrl
                            : viewSet.menu.menuId === currentMenu.menu.menuId;
                        const disp = isCurrentView ? 'block' : 'none';
                        const vis = isCurrentView ? 'visible' : 'hidden';
                        const renderMenu = viewSet.parentMenu && isCurrentView
                            ? currentMenu.menu
                            : viewSet.menu;
                        const renderParentMenu = viewSet.parentMenu && isCurrentView
                            ? currentMenu.parentMenu
                            : viewSet.parentMenu;
                        // key를 svcUrl 기반으로 유지: 같은 서비스 탭은 항상 동일한 key
                        // React가 같은 key와 컴포넌트 타입을 인식하면 인스턴스를 재사용
                        // 매번 렌더링할 때 최신 menu/parentMenu props를 전달
                        const keyValue = viewSet.menu.svcUrl || viewSet.menu.menuId;
                        const view = getViewFromMenu(renderMenu, renderParentMenu);
                        return (
                            <ContentBox key={keyValue} style={{display:disp, visibility:vis}}>
                                {view}
                            </ContentBox>
                        );
                    })
                }
                {
                    appViews.length <= 5 &&
                    <ShortHelpBox>
                        {
                            appViews.length < 4 &&
                            <ShortHelpText>
                                <span>대부분의 테이블은 왼쪽 상단의 </span>
                                <MenuIcon style={{
                                    fontSize:'0.95rem', color: '#33f', verticalAlign:'middle',
                                }}/>
                                <span> 아이콘을 클릭하여 엑셀로 저장할 수 있습니다.</span>
                            </ShortHelpText>
                        }
                        <IconButton size={AppWord.SMALL}
                            color={AppStyle.mui.info}
                            onClick={(e)=>setHelpAnchorEl(e.currentTarget)}
                        >
                            <InfoIcon/>
                        </IconButton>
                    </ShortHelpBox>
                }
            </MainContainer>
            <Popover
                open={Boolean(helpAnchorEl)}
                anchorEl={helpAnchorEl}
                onClose={()=>setHelpAnchorEl(null)}
                anchorOrigin={{ vertical: 'top', horizontal: 'right', }}
                transformOrigin={{ vertical: 'top', horizontal: 'right', }}
            >
                <PopHelpBox>
                    <dl>
                        <dt style={{fontWeight:'bold'}}>엑셀 저장</dt>
                        <dd>
                            <span>대부분의 테이블은 왼쪽 상단의 </span>
                            <MenuIcon style={{
                                fontSize:'0.95rem', color: '#33f', verticalAlign:'middle',
                            }}/>
                            <span> 아이콘을 클릭하여 엑셀로 저장할 수 있습니다.
                                다만, 일부 테이블은 엑셀 저장이 지원되지 않습니다.
                            </span>
                        </dd>
                        <dt
                            style={{
                                fontWeight:'bold', marginTop:10,
                                borderTop: '1px solid #ccc', paddingTop: 10
                            }}
                        >테이블 내용 복제하기</dt>
                        <dd>
                            테이블 내용 복제도 테이블 왼쪽 상단의 메뉴를 누른 후 
                            클립보드로 복사 메뉴아이템을 선택하면 됩니다.<br/>
                            복사한 내용은 엑셀에 붙여넣기 할 수 있으며, 하나의 레코드가 한 줄을 차지하고,
                            각 필드는 탭으로 구분되어 복사됩니다. 
                        </dd>
                        <dt
                            style={{
                                fontWeight:'bold', marginTop:10,
                                borderTop: '1px solid #ccc', paddingTop: 10
                            }}
                        >화면 하단의 시계</dt>
                        <dd>
                            화면 하단의 시계는 사용자의 PC 시간을 나타냅니다.
                            사용자마다 시간대 또는 시간이 다를 수 있습니다.
                        </dd>
                        <dt
                            style={{
                                fontWeight:'bold', marginTop:10,
                                borderTop: '1px solid #ccc', paddingTop: 10
                            }}
                        >로그아웃</dt>
                        <dd>
                            로그아웃은 화면 우측 상단의 자기 이름을 클릭하면 나오는 상자에서
                            로그아웃 버튼을 클릭하면 됩니다.
                            로그아웃 후에는 다시 로그인해야만 시스템을 사용할 수 있습니다.
                        </dd>
                    </dl>
                </PopHelpBox>
            </Popover>
            {/* AppHeader의 위치를 다른 곳으로 옮기지 말 것 */}
            <AppHeader
                onMenuSelected={onMenuSelected}
                onClickHomeLogo={onClickHomeLogo}
                onClickGoBbs={onClickGoBbs}
                onRequestOpenMaskDc={onRequestOpenMaskDc}
                onRequestOpenEditMyInfo={()=>setOpenEditMyInfo(true)}
                onRequestOpenChangeMyPassword={()=>setOpenChangeMyPassword(true)}
            />
            <MaskDsc
                open={openMaskDc}
                onClose={()=>setOpenMaskDc(false)}
                onRequestMask={onRequestMask}
                working={responseMaskDc.loading}
            />
            <UserInfoInputMine
                open={openEditMyInfo}
                onClose={()=>setOpenEditMyInfo(false)}
            />
            <UserInfoChangePassword
                open={openChangeMyPassword}
                onClose={()=>setOpenChangeMyPassword(false)}
            />
        </AppConfirmDialogProvider>
    );
}
/*
AppHeader의 위치를 다른 곳으로 옮기지 말 것.
현 위치보다 더 깊이 들어가면 Select 컴포넌트의 라벨이 메뉴 위로 나타나는 현상이 있음.
*/
